import axios from "axios";
import { API_BASE_URL } from "config";
import { condition } from "context/condition";
import { Globalstate } from "context/context";
import { useMutation } from "react-query";

const getTranslateResponse = async ({ botKey, language, text, source_code, userMsg, id }) => {
  const authToken = localStorage.getItem("authToken");
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_BASE_URL}/translate_response`,
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "application/json",
    },
    data: {
      source_code: source_code,
      lang_code: language,
      response: text,
    },
  };
  try {
    const data = await axios.request(config);
    return {
      data: {
        answer: data.data.trans_text,
        isTranslatedResponse: true,
        source_code: language,
        question: userMsg,
        id: id
      },
      key: botKey,
    };
  } catch (err) {
    console.log("Error: ", err);
    return {
      data: {
        answer: "Something Went Wrong! Please Try Again Later",
        cta_results: [],
        recommended_questions: [],
        id: "",
        isBingResponse: false,
        isTranslatedResponse: true,
        question: userMsg
      },
      key: botKey,
    };
  }
};

const useTranslateResponse = () => {
  const { dispatch } = Globalstate();
  return useMutation(getTranslateResponse, {
    onSuccess: (data) => {
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: data?.key,
          data: data.data,
        },
      });
      dispatch({
        type: condition.SETMESSAGESUBMITTED,
        payload: false,
      });
    },
    onError: (error) => {
      console.log("Error: ", error);
      dispatch({
        type: condition.UPDATEMESSGES,
        payload: {
          key: error?.key,
          data: error?.answer,
        },
      });
    },
  });
};

export default useTranslateResponse;